import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/store/auth";
import type { ReactNode } from "react";

export function AuthGuard({ children }: { children: ReactNode }) {
  const isAuthed = useAuth((s) => s.isAuthenticated());
  const loc = useLocation();
  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  }
  return <>{children}</>;
}
